import styled from '@emotion/styled'

export const Container = styled.div`
  gap: 1rem;
  display: flex;
`

export const ContainerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 48px;
  background: #FFFADF;
  border: 1px solid #F3CC04;
  border-radius: .4rem;

  svg {
    color: #F3CC04;
  }
`
export const FileList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: calc(100% - 32px);
  z-index: 1;
`

export const FileBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  background-color: #F0FAF6;
  border: 2px dashed #00A86B;
  border-radius: 6px;
  max-width: 250px;
`
